import './App.css';
import React from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import BuyTicket from "./pages/BuyTicket";
import RegisterTicket from "./pages/RegisterTicket";
import VerifyPayments from "./pages/VerifyPayments";
import ScanTicket from "./pages/ScanTicket";
import { AuthProvider, useAuth } from "./AuthContext";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useState } from "react";
import { app } from "./firebaseConfig";
import Login from "./pages/Login";
import { Navigate } from "react-router-dom";
import TagTicket from './pages/TagTicket';
import CheckInPage from './pages/CheckInPage';



// ✅ Authorized team emails
const authorizedEmails = [
  "orgchor19@gmail.com",
  "ccfdipologchurch@gmail.com",
  // Add more authorized emails if needed
];

// ✅ Route protection wrapper
const ProtectedRoute = ({ element }) => {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" />;
  if (!user || !authorizedEmails.includes(user.email)) {
    return <h2 style={{ color: 'white', textAlign: 'center' }}>Access Denied</h2>;
  }

  return element;
};

// ✅ Home page button
// ✅ Home page
const Home = () => {
  const { user } = useAuth();
  console.log("Logged in as:", user?.email); // Add this for debugging

  return (
    <div className="page-background">
      <div className="button-group">
        <Link to="/buy-ticket" className="nav-button">Buy Ticket</Link>
        <Link to="/register-ticket" className="nav-button">Register Ticket</Link>
        {user && authorizedEmails.includes(user.email) && (
          <>
            <Link to="/verify-payments" className="nav-button">Verify Payments</Link>
            <Link to="/tag-ticket" className="nav-button">Tag Ticket</Link> {/* 🎯 Add this line! */}
          </>
        )}
      </div>
    </div>
  );
};



// ✅ Main App component
const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/buy-ticket" element={<BuyTicket />} />
          <Route path="/register-ticket" element={<RegisterTicket />} />
          <Route path="/login" element={<Login />} />
          <Route path="/scan-ticket" element={<ScanTicket />} />
          <Route path="/verify-payments" element={<ProtectedRoute element={<VerifyPayments />} />} />
          <Route path="/tag-ticket" element={<TagTicket />} />
          <Route path="/checkin" element={<CheckInPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
